var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-icon",class:_vm.provider,style:({width: _vm.size + 'px', height: _vm.size + 'px'}),on:{"click":_vm.handlePin}},[_c('a',{ref:"emailLink",attrs:{"href":_vm.link}})])}
var staticRenderFns = []

export { render, staticRenderFns }